import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence, useReducedMotion } from 'framer-motion';
import logoHeader from '../assets/logo_header.webp';

// Elegant first-paint brand loader: logo fade + gold shimmer sweep, then fades out revealing the hero.
const BrandLoader = () => {
  const reduce = useReducedMotion();
  const [show, setShow] = useState(() => {
    try { return !sessionStorage.getItem('nnl_loaded'); } catch { return true; }
  });

  useEffect(() => {
    if (!show) return;
    const t = setTimeout(() => {
      setShow(false);
      try { sessionStorage.setItem('nnl_loaded', '1'); } catch (e) { if (process.env.NODE_ENV !== 'production') console.debug('brandloader flag persist failed', e); }
    }, reduce ? 500 : 1500);
    return () => clearTimeout(t);
  }, [show, reduce]);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          className="fixed inset-0 z-[200] flex items-center justify-center bg-[#0b0b0b]"
          initial={{ opacity: 1 }}
          exit={{ opacity: 0, transition: { duration: 0.7, ease: [0.5, 0, 0.75, 0] } }}
          data-testid="brand-loader"
        >
          <motion.div
            className="flex flex-col items-center"
            initial={{ opacity: 0, y: 14, scale: 0.98 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            transition={{ duration: 0.8, ease: [0.25, 1, 0.5, 1] }}
          >
            <div className="relative overflow-hidden">
              <img src={logoHeader} alt="Nikki's Next Level Hair and Beauty" className="h-[9rem] sm:h-[11.2rem] w-auto object-contain" />
              {!reduce && (
                <motion.div
                  className="absolute inset-0 pointer-events-none"
                  style={{ background: 'linear-gradient(105deg, transparent 35%, rgba(231,211,161,0.55) 50%, transparent 65%)' }}
                  initial={{ x: '-120%' }}
                  animate={{ x: '120%' }}
                  transition={{ duration: 1.2, ease: 'easeInOut', repeat: Infinity, repeatDelay: 0.1 }}
                />
              )}
            </div>
            <div className="mt-6 h-px w-24 bg-gradient-to-r from-transparent via-[#c6a15b] to-transparent" />
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default BrandLoader;
